define([
	'internal_util/Util',
	'model/bindings/AbstractKeyBindingType'
], function (
	Util,
	AbstractKeyBindingType
) {
	'use strict';

	/**
	 * WebCryptoKeyBindingType class
	 * 
	 * @returns {WebCryptoKeyBinding}
	 */
	return function (registrationData, nonce, pvr, salt) {
		
		AbstractKeyBindingType.call(this, "FIDO/U2F", salt);

		var _registrationData = registrationData,
				_nonce = nonce,
				_pvr = pvr;
		
		function base64ToArrayBuffer(base64) {
			var binary_string = window.atob(base64);
			var len = binary_string.length;
			var bytes = new Uint8Array(len);
			for (var i = 0; i < len; i++) {
				bytes[i] = binary_string.charCodeAt(i);
			}
			return bytes.buffer;
		}
		function normal64(base64) {
			return base64.replace(/\-/g, '+').replace(/_/g, '/') + '=='.substring(0, (3*base64.length)%4);
		}
		function bytes2Base64Native(bytes) {
			var binary = '';
			var bytes = bytes;
			var len = bytes.byteLength;
			for (var i = 0; i < len; i++) {
				binary += String.fromCharCode(bytes[i]);
			}
			return window.btoa(binary);
		}
		function webSafe64(base64) {
			return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
		}
	

		// public methods
		
		this.registrationData = function() {
			return _registrationData;
		};
		
		this.keyHandle = function() {
			var buff = base64ToArrayBuffer(normal64(_registrationData.registrationData));
			var dv = new DataView(buff, 0);
			var l = dv.getUint8(66);
			var h = new Uint8Array(l);
			for (var i = 0; i < l; i++) {
				  h[i] = dv.getUint8(i+67);
			  }
			var kh = webSafe64(bytes2Base64Native(h));
			return kh;
		};
		
		this.secret = function() {
			return null;
		};
		
		this.nonce = function() {
			return _nonce;
		}
		
		this.pvr = function() {
			return _pvr;
		}

		this.toObject = function () {
			return {
				type : this.type(),
				origin : this.origin(),
				salt: this.salt(),
				registrationData: _registrationData
			};
		};

	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/model/bindings/FidoU2FBindingType.js
// module id = 267
// module chunks = 2